const LoginFailure = () => {
  return <pre style={{
    margin:'10px 8px',
    fontSize:'unset',
  }}>Unexpected error uncountered while logging in.</pre>
}
export default LoginFailure